import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";

/* Floating bronze accents — URWAN medallion, zipper pull, open zipper seam. */
export default function FloatingAccents() {
    const reduce = useReducedMotion();
    const { scrollYProgress } = useScroll();
    const yFly = useTransform(scrollYProgress, [0, 1], [0, -140]);
    const yCoin = useTransform(scrollYProgress, [0, 1], [0, 70]);

    return (
        <div
            data-testid="floating-accents"
            aria-hidden="true"
            className="pointer-events-none fixed inset-0 z-40 overflow-hidden"
        >
            {/* open zipper fly — a seam left open along the left edge, drifting with scroll */}
            <motion.img
                src="/img/denim/zipper-fly-open.png"
                alt=""
                style={{ y: reduce ? 0 : yFly }}
                className="absolute -left-20 top-[30%] hidden w-32 opacity-60 drop-shadow-[0_0_30px_rgba(203,124,58,0.22)] lg:block"
            />

            {/* URWAN medallion — a brand coin tucked into the right edge */}
            <motion.div style={{ y: reduce ? 0 : yCoin }} className="absolute right-0 top-[44%]">
                <motion.img
                    src="/img/denim/medallion-coin.png"
                    alt=""
                    animate={reduce ? {} : { y: [0, -12, 0], rotateY: [-16, 10, -16] }}
                    transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
                    style={{ transformPerspective: 700 }}
                    className="-mr-7 w-14 opacity-90 drop-shadow-[0_12px_28px_rgba(0,0,0,0.65)] sm:-mr-9 sm:w-20 lg:-mr-12 lg:w-28"
                />
            </motion.div>
        </div>
    );
}
